// @flow
import React from "react"
import { compose, type HOC } from "recompose"
import withQuery from "hoc/withQuery"
import type { ProductVariant } from "data/product/types"
import { listPopularProductsByReservationCount } from "data/product/graphql/queries"
import ProductInventoryTile from "./ProductInventoryTile"
import { ProductsWrap } from "./styled"

/**
 * Renders a list of Products as ProductInventoryTile
 */
const ProductInventory = ({ data, loading, selectedInventory, onSelect, productGroups }) => {
  const products = removeDuplicateProductVariants(data.products, productGroups)
  return (
    <React.Fragment>
      <ProductsWrap>
        {products.map((product, idx) => (
          <ProductInventoryTile
            key={product.id}
            selectProduct={onSelect}
            product={product}
            activeProducts={selectedInventory}
          />
        ))}
      </ProductsWrap>
    </React.Fragment>
  )
}
/**
 * Remove the duplicate product variants within a product by comparing the
 * variant name.
 */
const removeDuplicateProductVariants = (products: any[], productGroups: any) => {
  const dedupedProducts: any[] = []
  for (let index = 0; index < products.length; index++) {
    const product = products[index]
    const variantShortNames: string[] = []
    const dedupedVariants: ProductVariant[] = []

    for (let j = 0; j < product.variants.length; j++) {
      const variant = product.variants[j]
      if (!variantShortNames.includes(variant.name)) {
        // Add to check list
        variantShortNames.push(variant.name)
        // Add to list of variants to return
        dedupedVariants.push(variant)
      }
    }
    dedupedProducts.push({
      ...product,
      variants: dedupedVariants
    })
  }
  return dedupedProducts
}

/**
 * Finds duplicate variants and groups them under the common Product that they belong to
 */
type Outter = {|
  // HACK(HARRY) productGroups from the selector intends to return an optional array of ProductGroup,
  // but instead returns a single ProductGroup
  productGroups: any,
  onSelect: Function,
  selectedInventory: ProductVariant[],
|}

const enhancer: HOC<*, Outter> = compose(
  withQuery(listPopularProductsByReservationCount, {
    variables: ({ productGroups}) => ({
      limit: 99,
      offset: 0,
      productGroup: productGroups ? productGroups.name : "skis",
      availableOnly: true,
    })
  }),
)

export default enhancer(ProductInventory)



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/InventorySelector/ProductInventory/index.js